import { makeStyles } from "tss-react/mui";
const useRatingStyles = makeStyles()(({ tokens, px }, _, classes)=>({
        root: {
            display: 'flex',
            width: '100%'
        },
        flexRow: {
            display: 'flex',
            width: '100%',
            justifyContent: 'center',
            flexWrap: 'nowrap',
            '& > *': {
                flex: 1
            }
        },
        flexLabel: {
            flex: 1,
            margin: 0,
            width: '100%',
            display: 'flex',
            '& .MuiFormControlLabel-label': {
                flex: 1,
                width: '100%'
            }
        },
        selected: {
            ["&.MuiChip-root"]: {
                backgroundColor: tokens.colors.original.brand.secondary,
                borderColor: tokens.colors.original.brand.primary,
                '& .MuiChip-icon': {
                    color: tokens.colors.accent.text.blue
                }
            }
        },
        hover: {
            ["&.MuiChip-root"]: {
                backgroundColor: tokens.colors.bg.greyscale.primary,
                ["&.MuiChip-outlined:hover:not(.Mui-disabled)"]: {
                    backgroundColor: tokens.colors.bg.greyscale.primary
                }
            },
            [`&.MuiChip-root.${classes.selected}`]: {
                backgroundColor: tokens.colors.original.brand.quaternary,
                ["&.MuiChip-outlined:hover:not(.Mui-disabled)"]: {
                    backgroundColor: tokens.colors.original.brand.quaternary
                }
            }
        },
        defaultRating: {
            flex: 1,
            width: '100%',
            backgroundColor: tokens.colors.bg.greyscale.secondary,
            borderColor: 'transparent',
            '& .MuiChip-icon': {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }
        },
        'iconSize-small': {
            '& .MuiChip-icon': {
                width: px(24),
                height: px(24),
                '& > svg': {
                    width: px(24),
                    height: px(24)
                }
            }
        },
        'iconSize-medium': {
            '& .MuiChip-icon': {
                width: px(32),
                height: px(32),
                '& > svg': {
                    width: px(32),
                    height: px(32)
                }
            }
        }
    }));
export { useRatingStyles };
